import type { Dnd5eAbilityScoreTag } from "@/lib/rules/dnd5e/vocabulary/ability-score";

export type ClassOption = {
  readonly className: string;
  readonly label: string;
  readonly recommendedAbilities: Readonly<Record<Dnd5eAbilityScoreTag, number>>;
  readonly classProfileId: string;
  readonly skillChoice?: {
    readonly field: string;
    readonly pool: string[];
    readonly count: number;
  };
};

/** Fetch selectable character classes from the kernel via the web proxy. */
export async function fetchClasses(): Promise<ClassOption[]> {
  const res = await fetch("/api/classes");
  if (!res.ok) {
    throw new Error("Failed to fetch classes");
  }
  return res.json() as Promise<ClassOption[]>;
}
